<template>
  <div>
    <Head>
      <!-- Primary Meta Tags -->
      <title>{{ titleOrFallback }}</title>
      <meta name="title" :content="titleOrFallback" />
      <meta name="description" :content="descriptionOrFallback" />

      <!-- Open Graph / Facebook -->
      <meta property="og:type" content="website" />
      <meta property="og:url" :content="currentPageURL" />
      <meta property="og:title" :content="titleOrFallback" />
      <meta property="og:description" :content="descriptionOrFallback" />
      <meta property="og:image" :content="props.image" v-if="props.image" />

      <!-- Twitter -->
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" :content="currentPageURL" />
      <meta property="twitter:title" :content="titleOrFallback" />
      <meta property="twitter:description" :content="descriptionOrFallback" />
      <meta
        property="twitter:image"
        :content="props.image"
        v-if="props.image"
      />
    </Head>
    <div class="tw-bg-white">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { Head } from "@inertiajs/vue3";
import { computed, defineProps } from "vue";
import { usePreloadStore } from "@/Tailwind/Stores/preload";

const props = defineProps({
  title: String,
  description: String,
});

const preloadStore = usePreloadStore();
preloadStore.loadLocations();
preloadStore.loadCategories();
preloadStore.loadUsers();
preloadStore.loadAssets();

const currentPageURL = window.location.href;
const titleOrFallback = computed(() =>
  props.title ? `FixForm - ${props.title}` : "FixForm"
);
const descriptionOrFallback = computed(
  () =>
    props.description ||
    "Keep buildings and spaces in good, safe and clean condition"
);
</script>
